import StringMask from 'string-mask';

export default (value) => {

  if (!value)
    return value;

  const realValue = parseFloat(value);
  const integerPart = Math.trunc(realValue);
  const decimalPart = Math.round((realValue - integerPart) * 100).toString();

  const decimalString = new StringMask('00', { reverse: true }).apply(decimalPart);

  return new StringMask('R$ #.##0,00', { reverse: true }).apply((`${integerPart}${decimalString}`));

};



// WEBPACK FOOTER //
// ./src/components/normalize/MoneyNormalize.js